import React, { useState, /*useEffect*/ } from 'react';
import styled from 'styled-components/macro';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';

import FadeInOutTransition from '../transitions/FadeInOutTransition';
import Loading from 'components/Loading';
import AngleIcon from 'components/AngleIcon';


SwiperCore.use([ Autoplay ]);

const defaultSwiperOptions = {
    centeredSlides:      true,
    loop:                true,
    preloadImages:       true,
    updateOnImagesReady: true,
    
    speed:    800,
    autoplay: {
        delay: 2000,
    },
};


const Slider = ({ children, className, controls = true, initialSlide = 0, ...props }) => {
    //const [ activeSlide, setActiveSlide ] = useState(false);
    const [ imagesReady, setImagesReady ] = useState(false);
    const [ swiper, setSwiper ] = useState(null);
    
    const swiperProps = { 
        ...defaultSwiperOptions, 
        initialSlide,
        ...props 
    };
    
    let isStart = true;
    let isEnd = true;
    
    if (React.Children.count(children) > 1) {
        if (swiperProps.loop) {
            isStart = false;
            isEnd = false;
        } else if (swiper) {
            isStart = swiper.isBeginning;
            isEnd = swiper.isEnd;
        }
    }
    
    return (
        <Container>
            <Swiper
                onSwiper={(swiper) => setSwiper(swiper)}
                onImagesReady={() => setImagesReady(true)}
                /*onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}*/
                {...swiperProps}
            >
                {React.Children.map(children, (child) => (
                    <SwiperSlide>
                        {child}
                    </SwiperSlide>
                ))}
            </Swiper>
            
            {controls && (
                <>
                    <PrevButton onClick={() => swiper && swiper.slidePrev()} isStart={isStart}>
                        <ButtonArrow/>
                    </PrevButton>
                    <NextButton onClick={() => swiper && swiper.slideNext()} isEnd={isEnd}>
                        <ButtonArrow flip/>
                    </NextButton>
                </>
            )}
            
            <FadeInOutTransition in={!imagesReady}>
                <ImagesLoading/>
            </FadeInOutTransition>
        </Container>
    );
};


export default Slider;


const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    
    & .swiper-container,
    & .swiper-wrapper {
        height: 100%;
    }
`;

const SliderButton = styled.button`
    position: absolute;
    top: 0;
    z-index: 1;
    
    width: 6rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    background: rgba(0,0,0,.3);
    border: none !important;
    outline: none !important;
    cursor: pointer;
    padding: 0;
    
    color: white;
    line-height: 1;
    
    transition: opacity .45s;
    
    opacity: .75;
    
    &:hover {
        opacity: 1;
    }
`;

const PrevButton = styled(SliderButton)`
    left: 0;
    padding-right: .5rem;
`;

const NextButton = styled(SliderButton)`
    right: 0;
    padding-left: .5rem;
`;

const ButtonArrow = styled(AngleIcon)`
    font-size: 4rem;
    transition: opacity .2s;
    position: relative;
`;

const ImagesLoading = styled(Loading)`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    
    background-color: white;
    
    font-size: 7rem;
`;
